import { useOrgAndSiteContext } from "@/context";
import { getStoredSelectedTeam, storeSelectedTeam } from "@/utils/common";
import { useRouter } from "next/router";
import { useEffect } from "react";

export default function HotLink() {
  const router = useRouter();

  const { currentOrganization } = useOrgAndSiteContext();

  useEffect(() => {
    if (!currentOrganization) {
      return;
    }

    const name = router.query.name;
    router.replace(`/hot/organization/${currentOrganization.slug}/${name}`);
    if (currentOrganization.slug !== getStoredSelectedTeam()) {
      storeSelectedTeam({ slug: currentOrganization.slug });
    }
  }, [currentOrganization, currentOrganization?.slug, router]);

  return <></>;
}
